import { FaceLandmarker } from "@mediapipe/tasks-vision"

/** A single mesh connector — derived from the SDK, whose `Connection` type isn't exported. */
export type Connection = (typeof FaceLandmarker.FACE_LANDMARKS_TESSELATION)[number]

/** One styled layer of the face mesh (a connector set + its stroke). */
export interface MeshConnectorStyle {
  connectors: Connection[]
  color: string
  lineWidth: number
}

/**
 * The mesh layers drawn over a face, mirroring the origene FaceProcessing look:
 * a faint full tesselation, colored eyes/eyebrows/irises (right red, left green),
 * and light face-oval + lips. Order matters — later layers paint on top.
 *
 * Computed once at module load (the `FACE_LANDMARKS_*` sets are static).
 */
export const FACE_MESH_LAYERS: MeshConnectorStyle[] = [
  { connectors: FaceLandmarker.FACE_LANDMARKS_TESSELATION, color: "#C0C0C070", lineWidth: 1 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_RIGHT_EYE, color: "#FF3030", lineWidth: 2 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_RIGHT_EYEBROW, color: "#FF3030", lineWidth: 2 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_LEFT_EYE, color: "#30FF30", lineWidth: 2 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_LEFT_EYEBROW, color: "#30FF30", lineWidth: 2 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_FACE_OVAL, color: "#E0E0E0", lineWidth: 3 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_LIPS, color: "#E0E0E0", lineWidth: 2 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_RIGHT_IRIS, color: "#FF3030", lineWidth: 1.5 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_LEFT_IRIS, color: "#30FF30", lineWidth: 1.5 },
]

/** The minimal full-strength layer set used for the final, settled mesh. */
export const FACE_MESH_FINAL_LAYERS: MeshConnectorStyle[] = [
  { connectors: FaceLandmarker.FACE_LANDMARKS_TESSELATION, color: "#C0C0C0", lineWidth: 1 },
  { connectors: FaceLandmarker.FACE_LANDMARKS_FACE_OVAL, color: "#E0E0E0", lineWidth: 3 },
]
